import {IconButton, Button, Hidden } from '@material-ui/core';
import {isWidthDown} from '@material-ui/core/withWidth';
import useWidth from 'hooks/useWidth';

const ResponsiveButton = ({children, breakpoint = 'xs', ...props}) => {
    const width = useWidth();

    return isWidthDown(breakpoint, width) ? (
        <IconButton {...props}>
            {props.startIcon || props.endIcon}
        </IconButton>
    ) : (
        <Button {...props}>
            <Hidden xsDown>
                {children || ''}
            </Hidden>
        </Button>
    );
};

export default ResponsiveButton;
